import { customInstance } from './customInstance';

/**
 * Výsledek testu přímého server-to-server spojení Phoenix → Magic
 * (endpoint <c>GET /api/integration/magic/hello</c>, viz Magic <c>PhoenixGatewayWebService.Hello</c>).
 * Zrcadlí backendový <c>MagicConnectionTestResponse</c>.
 */
export interface MagicConnectionTestResponse {
  success: boolean;
  error?: string | null;
  userId?: number | null;
  userName?: string | null;
  serverTimeUtc?: string | null;
  version?: string | null;
}

/**
 * Otestuje spojení s Magicem (config-only endpoint). Ručně psané (mimo orval) — jednoduchý
 * health-check pro tlačítko v tools menu; backend vrací úspěch i chybu jako <c>200</c> s příznakem
 * <c>success</c>, takže UI neřeší HTTP chyby.
 */
export const testMagicConnection = (signal?: AbortSignal) =>
  customInstance<MagicConnectionTestResponse>({
    url: '/api/integration/magic/hello',
    method: 'GET',
    signal,
  });
